import { css } from "@emotion/react";
import { LargeText } from "../../styles/styles";
import { COOLER_GREY, DARK_GREY, LIGHT_GREY } from "../../styles/colors";

export const accessRuleFieldset = css`
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;

  legend {
    padding: 0;
    margin: 0 0 6px 0;
    font: inherit;
    ${LargeText};
    font-weight: bold;
    margin-bottom: 10px;
  }
`;

export const dashCss = css`
  width: 10px;
  height: 2px;
  background-color: ${DARK_GREY};
  pointer-events: none;
  margin: 0 8px;
`;

export const rowContainer = css`
  margin-bottom: 7px;
  display: inline-flex;
  width: fit-content;
  align-items: center;
  padding: 4px;
  border-radius: 6px;
  background-color: ${LIGHT_GREY};
  box-shadow: inset 0 0 0 1px ${COOLER_GREY};
`;

export const inputBaseCss = css`
  width: 100%;
  box-sizing: border-box;
`;

export const dateTimeCss = css`
  width: 9.4rem;
  flex: 0 0 9.4rem;
`;

export const deleteButtonCss = css`
  background: none;
  border: none;
  padding: 4px;
  margin-left: 5px;
  margin-right: 5px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover img {
    opacity: 0.75;
  }
`;
